import ActionType from 'actions/ActionType'

export const handleGroupChange = payload => dispatch =>
  dispatch({ type: ActionType.SignupForm.HANDLE_GROUP_CHANGE, payload })

export const handleGroupSuggestionClick = payload => dispatch =>
  dispatch({
    type: ActionType.SignupForm.HANDLE_GROUP_SUGGESTION_CLICK,
    payload,
  })

export const selectFormType = payload => dispatch =>
  dispatch({ type: ActionType.SignupForm.SELECT_FORM_TYPE, payload })

export const handleFormViewSelect = payload => dispatch =>
  dispatch({ type: ActionType.SignupForm.HANDLE_FORM_VIEW_SELECT, payload })

export const handleFormValueChange = (property, payload) => dispatch =>
  dispatch({
    type: ActionType.SignupForm.HANDLE_FORM_VALUE_CHANGE,
    property,
    payload,
  })

export const handleFormFieldChange = payload => dispatch =>
  dispatch({ type: ActionType.SignupForm.HANDLE_FORM_FIELD_CHANGE, payload })
  
export const handleFormDrag = payload => dispatch =>
  dispatch({ type: ActionType.SignupForm.HANDLE_FORM_DRAG, payload })

export const formFieldRequiredChange = payload => dispatch =>
  dispatch({ type: ActionType.SignupForm.FORM_FIELD_REQUIRED_CHANGE, payload })

export const receiveForm = payload => (dispatch, getState) =>
  Promise.resolve(
    dispatch({
      type: ActionType.SignupForm.RECEIVE_FORM,
      payload,
      groupsByID: getState().contacts.groupsByID,
      preferences: getState().data?.['account/preference']?.preferences,
    }),
  )

export const toggleBottomNav = (event, payload) => dispatch =>
  dispatch({ type: ActionType.SignupForm.TOGGLE_BOTTOM_NAV, payload })

export const closeSnackbar = () => dispatch =>
  dispatch({ type: ActionType.SignupForm.CLOSE_SNACKBAR })

export const togglePreviewResponseView = (payload) => dispatch =>
  dispatch({ type: ActionType.SignupForm.TOGGLE_PREVIEW_RESPONSE_VIEW, payload })

export const toggleFormDataPanel = payload => dispatch =>
  dispatch({ type: ActionType.SignupForm.TOGGLE_FORM_DATA_PANEL, payload })

export const toggleBottomMenu = () => dispatch =>
  dispatch({ type: ActionType.SignupForm.TOGGLE_BOTTOM_MENU })
